var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_bottom"},[_c('img',{attrs:{"src":"http://static.dhsf.xqhuyu.com/box/publicity/346/60d5404a09272.jpg","alt":""}})])}]

export { render, staticRenderFns }